import { useDispatch, useSelector } from "react-redux";
import AdminPanel from "../components/AdminPanel";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import { useEffect } from "react";
import { getAdminProducts, setIsNeedRefresh } from "../redux/adminShopSlice";
import AdminCard from "../components/AdminCard";
import Loader from "../components/Loader";
import Error from '../components/Error';
import { GreenButton } from "../components/buttons";
import { setBacklink } from "../redux/backlinkSlice";

const HandleShop = () => {
    const { isLoading, error, data, isNeedRefresh } = useSelector(state => state.adminShop);
    const dispatch = useDispatch();

    // Eseguo la chiamata iniziale a admin-shop
    useEffect(() => {
        if (!data) {
            dispatch(getAdminProducts())
        }
    }, [data]);

    // Imposto il backlink su "/"
    useEffect(() => {
        dispatch(setBacklink("/"))
    }, [])

    // Chiamata al ritorno in pagina anche se data è già memorizzato in Redux
    // Questo l'ho disattivo per lavorare solo col isNeedRefresh (al contrario di Activities)
    /* useEffect(() => {
        if (data) {
            dispatch(getAdminProducts())
        }
    }, []); */

    // Rieffettuo la chiamata se isNeedRefresh viene settato
    useEffect(() => {
        if (isNeedRefresh) {
            dispatch(getAdminProducts());
            dispatch(setIsNeedRefresh(false));
        }
    }, [isNeedRefresh])

    return (
        <PageContainer px="4" desktopItems="center">
            <PageTitle title="Gestione shop" backLink="/" />

            <div className="SPLITPAGE flex flex-col md:flex-row gap-8">

                {/* Right */}
                <AdminPanel />

                {/* Left */}
                <div className="w-full max-w-[1000px] lg:min-w-[1000px]">

                    <div className="w-full flex justify-end mb-8">
                        <GreenButton text="Aggiungi prodotto" link="/add-edit-product" isFull />
                    </div>

                    <div className="flex flex-col gap-2 w-full">
                        {/* Barra dei titoli */}
                        <div className="hidden lg:flex flex-row gap-4 py-2 px-4">
                            <div className="w-[300px]">PRODOTTO</div>
                            <div className="w-[90px]">PREZZO</div>
                            <div className="w-[100px]">DATA</div>
                            <div className="w-[70px]">STATUS</div>
                            {<div className="w-[152px]"></div>}
                        </div>

                        {/* Cards */}
                        {
                            !isLoading && !error && data && data.length > 0 && data.map((element, index) => {
                                return <AdminCard key={index} elementData={element} type="Product" />
                            })
                        }
                        {isLoading && <Loader isMobileCenter />}
                        {error && <Error message={error.message || 'Errore sconosciuto'} />}
                    </div>
                </div>

            </div>

        </PageContainer>
    )
}

export default HandleShop;